import ENV from "app/utils/ENV";
import storageActions from "app/utils/storageActions";
import textHelpers from "app/utils/textHelpers";
import valueHelpers from "app/utils/valueHelpers";

let filterHelpers = {
  apply(values, affectLeveling = true) {
    let applyQuery = false;
    const store = require("app/redux/store").default;
    let { preferences, filters, app } = store.getState();

    let { datetime } = app;

    // let { query, level, } = this.state
    let query = "";
    let level = undefined;
    // let { hidePrompts, familyIds, date, } = this.props
    let familyIds = [];

    let { hiddenIds, focusIds } = preferences;
    let {
      showComplete,
      hideDoneToday,
      showHidden,
      showSnoozed,
      showFocus,
      showPrompts,
      showRipe,
      showArchived,
      showSubTasks,
      showNotes,
    } = filters;

    if (hideDoneToday == 1) {
      // hide progressed today
      // values = values.filter(v => !textHelpers.wasDoneToday(v, true))
      values = values.filter(
        (v) => !valueHelpers.wasProgressedToday(v, datetime)
      );
    }

    if (showNotes == 0) {
      // hide notes
      values = values.filter((v) => !v.is_note);
    } else if (showNotes == 2) {
      // only notes
      values = values.filter((v) => v.is_note);
    }

    if (showComplete == 0) {
      // hide complete
      values = values.filter((v) => !v.completed_at);
    } else if (showComplete == 2) {
      // only complete
      values = values.filter((v) => !!v.completed_at);
    }

    if (showArchived == 0) {
      // hide archived
      values = values.filter((v) => !v.archived_at);
      // values = values.filter((v) => !valueHelpers.isArchived(v, true));
    } else if (showArchived == 2) {
      // only archived
      values = values.filter((v) => !!v.archived_at);
    }

    return values;

    if (hideDoneToday == 2) {
      // only progressed today
      // let doneToday = values.filter(v => textHelpers.wasDoneToday(v, true))
      let doneToday = values.filter((v) =>
        valueHelpers.wasProgressedToday(v, datetime)
      );
      // let doneToday = values.filter(v => valueHelpers.wasProgressedToday(v))
      console.log(
        datetime,
        doneToday.map((v) => v.text)
      );
      let parentIds = doneToday.reduce(
        (ids, val) => [...ids, ...val.parent_ids],
        []
      );
      while (parentIds.length) {
        let newDoneToday = values.filter(
          (v) => parentIds.indexOf(v.id) >= 0 && doneToday.indexOf(v) < 0
        );
        parentIds = newDoneToday.reduce(
          (ids, val) => [...ids, ...val.parent_ids],
          []
        );
        doneToday = [...doneToday, ...newDoneToday];
      }
      values = doneToday;
    }

    // if (showHidden == 0 || showHidden == 2) {
    //   // values = values.filter(v => {
    //   //   if(filterHelpers.isHidden(v))
    //   // })
    //   let tempHiddenIds = hiddenIds?.length ? [...hiddenIds] : [];
    //   let hiddenRootIds = values
    //     .filter((v) => tempHiddenIds.includes(v.id))
    //     .map((v) => v.root_id);
    //   // values.filter(v => tempHiddenIds.includes(v.id)).forEach(value => {
    //   values
    //     .filter((v) => hiddenRootIds.includes(v.root_id))
    //     .forEach((value) => {
    //       valueHelpers.getDescendants(value).forEach((c) => {
    //         // if(!!c.parent_ids.length && !c.parent_ids.some(x => !tempHiddenIds.includes(x))){
    //         if (
    //           !!c.parent_ids.length &&
    //           !valueHelpers
    //             .getParents({ value: c })
    //             .some((p) => !hiddenRootIds.includes(p.root_id))
    //         ) {
    //           tempHiddenIds.push(c.id);
    //           hiddenRootIds.push(c.root_id);
    //         }
    //       });
    //     });
    //   // let hiddenRootIds = values.filter(v => tempHiddenIds.includes(v.id)).map(v => v.root_id)
    //   let shouldRemove = showHidden == 2;
    //   values = values.filter((v) => {
    //     // if(tempHiddenIds.includes(v.id)){
    //     //   return shouldRemove
    //     // }
    //     if (hiddenRootIds.includes(v.root_id)) {
    //       return shouldRemove;
    //     }
    //     return !shouldRemove;
    //   });
    // }

    let tempFocusIds = focusIds?.length ? [...focusIds] : [];
    // if(showFocus==0 || showFocus==2){ // trinary
    if (!!showFocus) {
      let focusFamilyIds = [];
      values
        .filter((v) => tempFocusIds.includes(v.id))
        .forEach((v) => {
          let familyIds = valueHelpers.getFamily(v).map((f) => f.id);
          focusFamilyIds = [...focusFamilyIds, ...familyIds];
        });
      // let shouldRemove = showFocus == 2 // trinary
      let shouldRemove = true;
      values = values.filter((v) => {
        if (tempFocusIds.includes(v.id)) {
          return shouldRemove;
        }
        // if(showFocus == 2){ // trinary
        // let familyIds = textHelpers.getFamilyIds(v, values, '', null, 'down')
        // if(tempFocusIds.some(id => familyIds.includes(id))){
        //   return shouldRemove
        // }
        // }
        // if(familyIds.includes(v.id)){
        //   return shouldRemove
        // }
        if (focusFamilyIds.includes(v.id)) {
          return shouldRemove;
        }
        return !shouldRemove;
      });
    }

    if (!showSubTasks) {
      values = values.filter((v) => !filterHelpers.isSubTask(v, values));
    }

    if (!!showRipe) {
      values = values.filter((value) => {
        if (value.cycle === 0) return false;
        let cycle = value.cycle || ENV.CYCLE;
        let progressions = valueHelpers.getProgressions({ value });
        if (progressions.length >= cycle - 1) {
          return true;
        }
        return false;
      });
    }

    if (showSnoozed == 0)
      // none
      values = values.filter((v) => !valueHelpers.isSnoozed(v));
    else if (showSnoozed == 1)
      // either
      values = values;
    else if (showSnoozed == 2)
      // only
      values = values.filter((v) => valueHelpers.isSnoozed(v));

    if (!affectLeveling) {
      // hide if level > 0 and no visible children
      // values = values.filter(v => !(v.level > 0 && !values.find(f => v.child_ids.includes(f.id) )))
    }

    // if(!showPrompts || hidePrompts){
    //   values = values.filter(value => !(typeof value.id == 'string' && value.id.includes('ftue')))
    // }

    if (applyQuery !== false) {
      values =
        !!query && query.length > 0
          ? values.filter((v) => {
              return (
                v.text.toLowerCase().includes(query.toLowerCase()) ||
                (!!v.revisions &&
                  v.revisions.find((r) =>
                    r.text.toLowerCase().includes(query.toLowerCase())
                  ))
              );
            })
          : values;
    }

    // if(!!level || level === 0){
    //   values = values.filter(v => v.level == level)
    // }

    // console.log('applyfilters res:', values)
    return values;
  },
  isHidden(value, recursively = true) {
    // let { values, preferences } = store.getState();
    // let { hiddenIds } = preferences;

    // let tempHiddenIds = hiddenIds?.length ? [...hiddenIds] : [];
    // let hiddenRootIds = values
    //   .filter((v) => tempHiddenIds.includes(v.id))
    //   .map((v) => v.root_id);

    // values
    //   .filter((v) => hiddenRootIds.includes(v.root_id))
    //   .forEach((value) => {
    //     valueHelpers.getDescendants(value).forEach((c) => {
    //       if (
    //         !!c.parent_ids.length &&
    //         !valueHelpers
    //           .getParents({ value: c })
    //           .some((p) => !hiddenRootIds.includes(p.root_id))
    //       ) {
    //         // tempHiddenIds.push(c.id)
    //         hiddenRootIds.push(c.root_id);
    //       }
    //     });
    //   });

    // if (hiddenRootIds.includes(value.root_id)) {
    //   return true;
    // }
    return false;
  },
  isSubTask(value, values = null) {
    const store = require("app/redux/store").default;
    values = values || store.getState().values;
    let projectIds = values.filter((v) => v.cycle === 0).map((v) => v.id);
    if (value.cycle == 1) {
      return true;
    }
    if (
      !!value.parent_ids?.length &&
      !value.parent_ids?.some((x) => !projectIds.includes(x))
    ) {
      return true;
    }
    return false;
  },
  defaultFilters() {
    return {
      // query: '',
      showComplete: ENV.DEMO ? 1 : 0,
      showPrompts: ENV.DEMO ? 1 : 0,
      // showPrompts: props.showPrompts !== undefined ? props.showPrompts : (ENV.DEMO ? 1 : 0),
      showHidden: 0,
      fromBottom: 1,
      showSnoozed: 0,
      hideDoneToday: 0,
      showFocus: 0,
      showArchived: 0,
      showRipe: 0,
      showSubTasks: 0,
      showNotes: 0,
      // level: undefined,
      // topLevel: 99,
    };
  },
  defaultFocusFilters() {
    return {
      showComplete: 1,
      showPrompts: 1,
      showHidden: 1,
      fromBottom: 1,
      showSnoozed: 0,
      hideDoneToday: 0,
      showFocus: 0,
      showArchived: 0,
      showRipe: 0,
      showSubTasks: 1,
    };
  },
  defaultTimelineFilters() {
    return {
      showComplete: 1,
      showPrompts: 1,
      showHidden: 0,
      fromBottom: 1,
      showSnoozed: 1,
      hideDoneToday: 0,
      showFocus: 0,
      showArchived: 0,
      showRipe: 0,
      showSubTasks: 1,
    };
  },
  defaultReviewDayFilters() {
    return {
      showComplete: 1,
      showPrompts: 1,
      showHidden: 0,
      fromBottom: 1,
      showSnoozed: 1,
      hideDoneToday: 2,
      showFocus: 0,
      showArchived: 0,
      showRipe: 0,
      showSubTasks: 1,
    };
  },
};

export default filterHelpers;
